module.exports = __webpack_public_path__ + "img/home-bg_old.3efd44f8.png";